module.exports = __webpack_public_path__ + "static/media/galerija_2022_0050.64dc88d0.jpg";